// Corresponds with app/models/boost/statuses.rb
export const BOOST_AVAILABLE = 'AVAILABLE';
export const BOOST_ELIGIBLE = 'ELIGIBLE';
export const BOOST_BOOSTED = 'BOOSTED';
export const BOOST_PAUSED = 'BOOST_PAUSED';

export const ALL_BOOST_STATUSES = [BOOST_AVAILABLE, BOOST_ELIGIBLE, BOOST_BOOSTED, BOOST_PAUSED];
